import { Spinner } from "@/components/ui/spinner";
import { VStack } from "@/components/ui/vstack";
import { useOrganizationControllerFindOne } from "@/generated/api/api";
import { EmptyState } from "@/screens/common/empty.state";
import { RestaurantTeamListFull } from "@/screens/restaurants/details/restaurant.team.list";
import { Stack, useLocalSearchParams } from "expo-router";

export default function FullList() {
  const { orgId } = useLocalSearchParams<{ orgId: string }>();

  const { data: organization, isLoading, isLoadingError } =
    useOrganizationControllerFindOne(orgId);

  if (isLoading) {
    return (
      <>
        <Stack.Screen options={{ title: "Team" }} />
        <VStack className="h-full w-full items-center justify-center">
          <Spinner size="large" />
        </VStack>
      </>
    );
  }

  if (isLoadingError || !organization) {
    return (
      <>
        <Stack.Screen options={{ title: "Team" }} />
        <VStack className="h-full w-full p-4">
          <EmptyState
            title="Something went wrong"
            description="Please check your internet connection and try again"
          />
        </VStack>
      </>
    );
  }

  return (
    <>
      <Stack.Screen options={{ title: "Team" }} />
      <RestaurantTeamListFull organization={organization} />
    </>
  );
}
